import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from "src/@/components/ui/button";
import Iconify from 'src/components/Iconify';

export default function InternetConnectionAlertPage() {
  const { t } = useTranslation('dashboard');

  return (
    <div className="flex h-screen flex-col items-center justify-center bg-gray-100">
      <div className="text-center">
        <Iconify className="mb-6 w-40 h-40 mx-auto text-red-400" icon="mdi:cloud-off-outline" />
        <h1 className="text-2xl font-bold text-gray-800">
          {t('connection.title')}
        </h1>
        <p className="mt-2 text-gray-600">
          {t('connection.description')}
        </p>
        <Button
          className="mt-6"
          onClick={() => window.location.reload()}
        >
          {t('connection.retry')}
        </Button>
      </div>
    </div>
  );
}
